import { Box } from '@mui/material';
import React from 'react'
import { Container, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const NoBlog = () => {

    const RecentBlog = [
        {
            img: './assets/images/blog-detail-1.png',
            title: 'Is slower team communication a bad thing?',
            date: '4 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-2.png',
            title: 'Is slower team communication a bad thing?',
            date: '23 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-3.png',
            title: 'Is slower team communication a bad thing?',
            date: '14 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-1.png',
            title: 'The Power of Smart Warehouse Management System in 2024',
            date: '8 March 2024',
            path: '/blog-detail'
        },
    ]

    const blogTag = [
        {
            tagTitle: 'Development',
            path: '/DevelopBlogList'
        },
        {
            tagTitle: 'Technology',
            path: '/TechBlogList'
        },
        {
            tagTitle: 'HTML',
            path: '/HtmlBlogList'
        },
        {
            tagTitle: 'Branding',
            path: '/BrandBlogList'
        },
        {
            tagTitle: 'PHP',
            path: '/PhpBlogList'
        }
    ]

    const BlogList = [
        {
            blogImg: '/assets/images/blog-1.png',
            blogTitle: 'Software Technology Trends in 2024: A Glance At The Future...',
            blogBtn: 'Read More',
            path: '/blog-detail'
        },
        {
            blogImg: '/assets/images/blog-2.png',
            blogTitle: 'The Power of Smart Warehouse Management System in 2024',
            blogBtn: 'Read More',
            path: '/blog-warehouse'
        },
        {
            blogImg: '/assets/images/blog-3.png',
            blogTitle: 'Unlocking Growth for B2B Enterprises with Performance',
            blogBtn: 'Read More',
            path: '/blog-growth'
        },
        {
            blogImg: '/assets/images/blog-1.png',
            blogTitle: 'Software Technology Trends in 2024: A Glance At The Future...',
            blogBtn: 'Read More',
            path: '/blog-detail'
        },
        {
            blogImg: '/assets/images/blog-2.png',
            blogTitle: 'The Power of Smart Warehouse Management System in 2024',
            blogBtn: 'Read More',
            path: '/blog-warehouse'
        },
        {
            blogImg: '/assets/images/blog-3.png',
            blogTitle: 'Unlocking Growth for B2B Enterprises with Performance',
            blogBtn: 'Read More',
            path: '/blog-growth'
        }
    ]


    const location = useLocation();
    const { searchQuery, filteredTags = [], filteredBlogs = [] } = location.state || {};

    const hasTags = filteredTags.length > 0;
    const hasBlogs = filteredBlogs.length > 0;


    
    return (
        <>

            <section className='about-page'>
                <div className='blog-list-bg'>
                    <div className='c-detail-shap-1 con-shap-c'>
                        <img src="../assets/images/whi-5.svg" alt="" />
                    </div>
                    <div className='about-shap-3'>
                        <img src="../assets/images/about-shap-1.png" alt="" />
                    </div>
                    <div className='about-shap-5 con-shap-c'>
                        <img src="../assets/images/about-shap-3.svg" alt="" />
                    </div>
                    <Container>
                        <Row className='align-items-center justify-content-center'>
                        
                            <div className='col-md-10 col-11' data-aos="fade-up" data-aos-duration="2000">
                                <div className='tech-content text-center ms-0'>
                                    <h2 className='mb-0'>Search Results for: {searchQuery}</h2>
                                </div>
                            </div>
                        </Row>
                    </Container>
                </div>
            </section>
            
            <section className='no-blog-padding'>
                <Container>
                    <Row>
                        <div className="col-lg-7 col-xl-8">
                            {/* Display Filtered Tags */}

                            {/* Show error messages only when relevant */}
                            {!hasTags && !hasBlogs && (
                            <div className="no-found">
                                <p className="mb-0">No Result found for &quot;{searchQuery}&quot;</p>
                            </div>
                            )}


                            {/* If there are tags, show them */}
                            {hasTags && (
                            <div>
                                
                                <Row>
                                    {
                                        BlogList.map((blogCard,index)=>(
                                            <div className='col-lg-6 col-md-6 col-sm-6 mb-30' key={index}>
                                                <div className='item blog-list-item'>
                                                    <Link to={blogCard.path}>
                                                        <div className='blog-card-list'>
                                                            <div className='blog-img blog-img-list'>
                                                                <img src={blogCard.blogImg} alt="Blog-Image" />
                                                            </div>
                                                            <div className='body-blog'>
                                                                <h3>{blogCard.blogTitle}</h3>
                                                                <Link to={blogCard.path}>
                                                                    <button className='read-more'>{blogCard.blogBtn}</button>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    
                                                    </Link>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </Row>

                            </div>
                            )}

                            {/* If there are filtered blogs, show them */}
                            {hasBlogs && (
                            <div className="mt-4">
                                
                                <Row>
                                    {filteredBlogs.map((blog, i) => (
                                        <div className="col-lg-6 col-md-6 col-sm-6 mb-30" key={i}>
                                        <div className="item blog-list-item">
                                            <Link to={blog.path}>
                                            <div className="blog-card-list">
                                                <div className="blog-img blog-img-list">
                                                <img src={blog.img} alt={blog.title} />
                                                </div>
                                                <div className="body-blog">
                                                <h3>{blog.title}</h3>
                                                <button className="read-more">Read More</button>
                                                </div>
                                            </div>
                                            </Link>
                                        </div>
                                        </div>
                                    ))}
                                </Row>
                            </div>
                            )}

                            

                        </div>

                        <div className="col-xl-4 col-lg-5 mt-lg-0">
                            <div className='ml-lg-30 ml-0'>

                                <div className=' mb-20' data-aos="fade-up-left" data-aos-duration="2500">
                                    <div className='blog-border'>
                                        <h4>Recent Blog</h4>
                                        <div className='border-blog'></div>
                                        <ul>
                                            {RecentBlog.map((blog, index) => (
                                                <li key={index}>
                                                    <Link to={blog.path}>
                                                        <Box sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '13px'
                                                        }}>
                                                            <div className='blog-list-img'>
                                                                <img src={blog.img} alt="" />
                                                            </div>
                                                            <div className='blog-list-text'>
                                                                <h6>{blog.title}</h6>
                                                                <p>{blog.date}</p>
                                                            </div>
                                                        </Box>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>

                                <div className='blog-border' data-aos="fade-up-left" data-aos-duration="2000">
                                    <h4>Tag Cloud</h4>
                                    <div className='border-blog'></div>
                                    
                                    <Box sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: '10px'
                                    }}>
                                        {
                                            blogTag.map((tag,index) => (
                                                <Link key={index} to={tag.path}>
                                                    <p className="tag-badge">{tag.tagTitle}</p>
                                                </Link>
                                            ))
                                        }
                                    </Box>
                                    
                                </div>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default NoBlog
